export const NAME = "name"
export const FIRSTNAME = "firstName"
export const LASTNAME = "lastName"
export const EMAIL = "email"
export const PHONE = 'phone'
export const MESSAGE = "message"



export const PLACEHOLDER_MSG_TO = "Une question, une info à donner ? J'écris mon message ici !"